import React from "react";
import { Button, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { File } from "../../../docuclipper/DocuclipperTypes";
import { ReduxState } from "../../../redux";
import { UPDATE_FILE } from "../../../redux/reducers/Files";
import { addFile } from "../../../redux/reducers/FilesServer";
import { closeModal } from "../../../redux/reducers/ModalManager";

type Props = {};
export const Password: React.SFC<Props> = ({}) => {
  const { activeModal } = useSelector(
    (state: ReduxState) => state.ModalManager
  );
  const { files } = useSelector((state: ReduxState) => state.Files);
  const files2 = files as File[];
  const dispatch = useDispatch();

  const uploadFile = () => {
    for (const f of files2) {
      dispatch({
        type: UPDATE_FILE,
        payload: {
          file: {
            file: f.file,
            needsPassword: false,
          },
        },
      });
      addFile({
        file: f.file,
        isCamera: false,
        asyncProcessing: false,
        customerId: null,
        withCompression: false,
        password: f.password,
      })(dispatch);
    }
  };
  return (
    <Modal
      show={activeModal === "password"}
      onHide={() => dispatch(closeModal("password"))}
    >
      <Modal.Header closeButton={true}>Enter password</Modal.Header>
      <Modal.Body>
        {files2
          .filter((f) => f.needsPassword)
          .sort((a, b) => a.file.name.localeCompare(b.file.name))
          .map((f, i) => (
            <Form.Group key={i} controlId="formBasicEmail">
              <Form.Label>{f.file.name}</Form.Label>
              <Form.Control
                placeholder="password"
                type="password"
                value={f.password || ""}
                onChange={(e) =>
                  dispatch({
                    type: UPDATE_FILE,
                    payload: {
                      file: {
                        file: f.file,
                        password: e.target.value,
                      },
                    },
                  })
                }
              />
            </Form.Group>
          ))}
        <Row className="justify-content-end p-2">
          <Button
            onClick={() => dispatch(closeModal("password"))}
            variant="secondary"
            className=""
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              uploadFile();
              dispatch(closeModal("password"));
            }}
            variant="primary"
            className="mx-1"
          >
            Save
          </Button>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default Password;
